import { render, staticRenderFns } from "./values-by-insrer-and-non-insurance-summary.vue?vue&type=template&id=0b8e1904&scoped=true"
import script from "./values-by-insrer-and-non-insurance-summary.vue?vue&type=script&lang=js"
export * from "./values-by-insrer-and-non-insurance-summary.vue?vue&type=script&lang=js"
import style0 from "./values-by-insrer-and-non-insurance-summary.vue?vue&type=style&index=0&id=0b8e1904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8e1904",
  null
  
)

export default component.exports